var render = function render(){var _vm=this,_c=_vm._self._c;return _c('feather-icon',{attrs:{"icon":"FileTextIcon","svgClasses":"w-5 h-5 hover:text-primary stroke-current ml-5"},on:{"click":function($event){return _vm.getBookLists()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }